// Domivus unit nomenclature
export const UNIT_KINDS = {
  1: "Wohneinheit",
  2: "Gewerbeeinheit",
  3: "Kellereinheit",
  4: "Speichereinheit",
  5: "Außenstellplatzeinheit",
  6: "Tiefgaragenstellplatzeinheit",
  7: "Garageneinheit",
};

export const FLOOR_CODES = {
  "99": "UG (Untergeschoss)",
  "98": "Außen",
  "00": "EG (Erdgeschoss)",
  "01": "1. OG",
  "02": "2. OG",
  "03": "3. OG",
  "04": "4. OG",
  "05": "5. OG",
  "06": "6. OG",
  "07": "7. OG",
  "08": "8. OG",
  "09": "9. OG",
  "10": "10. OG",
};

// Wohnungs-Position: keine Auswahl (= 1, automatisch fortlaufend) ODER links/mitte/rechts
export const POSITIONS = {
  0: "automatisch (fortlaufend)",
  1: "links",
  2: "mitte",
  3: "rechts",
};

// Lage der Einheit im Geschoss (z. B. für die Wohnungsgeberbescheinigung)
export const UNIT_SIDES = ["links", "mitte", "rechts", "vorne", "hinten", "links vorne", "rechts vorne", "links hinten", "rechts hinten"];

export const TENANCY_TYPES = {
  "01": "Wohnraummietvertrag",
  "02": "Gewerbemietvertrag",
  "03": "Kellermietvertrag",
  "04": "Speichermietvertrag",
  "05": "Außenstellplatzmietvertrag",
  "06": "Tiefgaragenstellplatzmietvertrag",
  "07": "Garagenmietvertrag",
};

// Mapping unit_kind → tenancy_type (1:1)
export const UNIT_KIND_TO_TENANCY_TYPE = {
  1: "01", 2: "02", 3: "03", 4: "04", 5: "05", 6: "06", 7: "07",
};

// VM-14d — Ausstattungs-Auswahlwerte für dynamische Einheiten-Anlage
export const FURNISHING_OPTIONS = {
  empty: "Unmöbliert",
  partial: "Teilmöbliert",
  full: "Vollmöbliert",
};
export const QUALITY_STANDARD_OPTIONS = {
  simple: "Einfach",
  standard: "Standard",
  premium: "Gehoben",
  luxury: "Luxus",
};
export const GARAGE_KIND_OPTIONS = {
  single: "Einzelgarage",
  double: "Doppelgarage",
  underground: "Tiefgarage",
  carport: "Carport",
  outdoor: "Außenstellplatz",
};
export const GARAGE_DOOR_OPTIONS = {
  swing: "Schwingtor",
  sectional: "Sektionaltor",
  rolling: "Rolltor",
  manual: "Manuell",
};

// Phase 21α: Wohnungstypen (nur sinnvoll bei unit_kind=1 = Wohneinheit)
export const APARTMENT_SUBTYPES = {
  "ground_floor":    "Erdgeschosswohnung",
  "floor_apartment": "Etagenwohnung",
  "maisonette":      "Maisonettewohnung",
  "attic":           "Dachgeschosswohnung",
  "penthouse":       "Penthouse-Wohnung",
  "souterrain":      "Souterrain-Wohnung",
};

export function buildUnitNumber(propertyNumber, kind, floorCode, position) {
  if (!propertyNumber) return "";
  const p = String(position).padStart(2, "0");
  const f = String(floorCode).padStart(2, "0");
  return `${propertyNumber}.${kind}.${f}.${p}`;
}
